import { Component } from '@angular/core';
import { FeedbackPlatformNotificationTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Notification Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformnotificationtype-form',
    templateUrl: './feedbackplatformnotificationtype.form.component.html'
})
export class FeedbackPlatformNotificationTypeFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformNotificationTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'notifications', sectionName: 'Notifications', isExpanded: false },
            { sectionKey: 'userNotificationSettings', sectionName: 'User Notification Settings', isExpanded: false }
        ]);
    }
}

